module.exports = __webpack_public_path__ + "static/img/26.c4d14e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/26.jpg
// module id = DnQl
// module chunks = 0